var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadAndroid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 53,
    viewBox: "0 0 53 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_523_2435)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 53,
    height: 53,
    rx: 9.63636,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_523_2435)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.5916 20.9799H33.4059C33.925 20.9799 34.3455 21.3976 34.3455 21.9134V34.1545C34.3455 34.6703 33.925 35.088 33.4059 35.088H19.5916C19.0725 35.088 18.652 34.6703 18.652 34.1545V21.9111C18.652 21.3953 19.0725 20.9775 19.5916 20.9775V20.9799Z",
    fill: "#A8A8A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.362 20.9795H18.6381V27.4093H34.362V20.9795Z",
    fill: "#A8A8A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5454 29.5759C38.5454 30.4931 37.7961 31.2376 36.873 31.2376C35.9498 31.2376 35.2005 30.4931 35.2005 29.5759V22.1099C35.2005 21.1927 35.9498 20.4482 36.873 20.4482C37.7961 20.4482 38.5454 21.1927 38.5454 22.1099V29.5759Z",
    fill: "#A8A8A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7995 29.5759C17.7995 30.4931 17.0501 31.2376 16.127 31.2376C15.2038 31.2376 14.4545 30.4931 14.4545 29.5759V22.1099C14.4545 21.1927 15.2038 20.4482 16.127 20.4482C17.0501 20.4482 17.7995 21.1927 17.7995 22.1099V29.5759Z",
    fill: "#A8A8A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7015 20.0612C18.7015 20.0612 18.8753 13.4494 26.4977 13.4727C34.0496 13.4961 34.2939 20.0612 34.2939 20.0612H18.7015Z",
    fill: "#A8A8A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0775 17.6171C23.5964 17.6171 24.017 17.1991 24.017 16.6835C24.017 16.168 23.5964 15.75 23.0775 15.75C22.5585 15.75 22.1379 16.168 22.1379 16.6835C22.1379 17.1991 22.5585 17.6171 23.0775 17.6171Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9224 17.6171C30.4414 17.6171 30.862 17.1991 30.862 16.6835C30.862 16.168 30.4414 15.75 29.9224 15.75C29.4035 15.75 28.9828 16.168 28.9828 16.6835C28.9828 17.1991 29.4035 17.6171 29.9224 17.6171Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8191 14.3586C22.8473 14.3983 22.9318 14.3843 23.0094 14.3306C23.0869 14.2769 23.1268 14.1999 23.0986 14.1625L21.6423 12.1204C21.6141 12.0807 21.5295 12.0947 21.452 12.1484C21.3745 12.2021 21.3346 12.2791 21.3627 12.3188L22.8191 14.3609V14.3586Z",
    fill: "#A8A8A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1808 14.3586C30.1526 14.3983 30.0681 14.3843 29.9906 14.3306C29.9131 14.2769 29.8731 14.1999 29.9013 14.1625L31.3577 12.1204C31.3859 12.0807 31.4704 12.0947 31.5479 12.1484C31.6254 12.2021 31.6654 12.2791 31.6372 12.3188L30.1808 14.3609V14.3586Z",
    fill: "#A8A8A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4 39.24C31.4 40.1572 30.6507 40.9017 29.7275 40.9017C28.8044 40.9017 28.0551 40.1572 28.0551 39.24V31.774C28.0551 30.8568 28.8044 30.1123 29.7275 30.1123C30.6507 30.1123 31.4 30.8568 31.4 31.774V39.24Z",
    fill: "#A8A8A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9449 39.24C24.9449 40.1572 24.1956 40.9017 23.2724 40.9017C22.3493 40.9017 21.6 40.1572 21.6 39.24V31.774C21.6 30.8568 22.3493 30.1123 23.2724 30.1123C24.1956 30.1123 24.9449 30.8568 24.9449 31.774V39.24Z",
    fill: "#A8A8A8"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_523_2435",
    x: 0,
    y: 0,
    width: 54.2045,
    height: 54.2045,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1.20455,
    dy: 1.20455
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.21591
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_523_2435"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_523_2435"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24.091,
    height: 28.8044,
    fill: "white",
    transform: "translate(14.4545 12.0977)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadAndroid);
export default __webpack_public_path__ + "static/media/download_android.5c231c1df872cc093a83fad97ae85bb4.svg";
export { ForwardRef as ReactComponent };